import KudoID from '@openly-engineering/kudo/plugins/kudo-id'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(KudoID)
})
